import React from 'react'
import styled from 'styled-components'
import { useTranslation } from '@i18n'
import { imageUrl, openPost } from '@libs/appUrl'
import { useCleanPostData } from '@features/post/contexts/CleanPostDataContext'
import CommentItem from './CommentItem'
import useDownloadAppDynamicLink from '@hooks/useDynamicLinkForDownloadApp'

const Container = styled.div`
  padding: 15px;
  padding-bottom: 50px;
  border-radius: 4px;
  background-color: #fff;
  margin-bottom: 10px;
`

const TopLine = styled.div`
  width: 100%;
  margin-bottom: 32px;
  height: 1px;
  background: #e6e6e6;
`

const TitleContainer = styled.div`
  display: flex;
  line-height: 1;
  margin-bottom: 15px;

  & > * {
    padding: 5px;
  }
`

const Title = styled.div`
  margin: 0 16px 12px 0;
  font-size: 18px;
  font-weight: 600;
`

const ReplyClickContainer = styled.div`
  display: flex;
  padding: 5px 0px 15px;
`

const ReplyClick = styled.a`
  cursor: pointer;
  width: calc(100% - 45px);
  line-height: 30px;
  background-color: #f7f7f7;
  color: #999999;
  padding: 5px 5px 5px 16px;
  margin-left: 10px;
  border-radius: 24px;
  box-sizing: border-box;
`

const DownloadAppContainer = styled.div`
  display: flex;
  justify-content: center;
`

const DownloadAppImageBox = styled.div`
  width: 100%;
  max-width: 480px;
  position: relative;
`

const DownloadAppClick = styled.a`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  max-width: 480px;
  min-height: 102px;
  max-height: 169px;
`


const GliaCloudContainer = styled.div`
  width: auto;
`

export type Comment = {
  b: number
  replyID: number
  text: string
  t: number
  like: number
  userInfo: {
    mid: string
    name: string
    img: string
    author: false
    d: false
  }
  _id: string
  postID: string
  ut: number // updated timestamp
}

type Props = {
  comments: Comment[]
  url: string
}

function CommentSection(props: Props) {
  const { t } = useTranslation()
  const { comments, url } = props

  const { userProfile } = useCleanPostData()
  const downloadAppLink = useDownloadAppDynamicLink()
  const b0Comments: Comment[] = comments.filter(({ b }) => b === 0)

  return (
    <Container>
      <TopLine />
      <TitleContainer>
        <Title>{t('post:留言區')}</Title>
      </TitleContainer>
      <ReplyClickContainer>
        <amp-img
          width="30"
          height="30"
          src={imageUrl('img/head2.png')}
          style={{ borderRadius: '50%' }}
        />
        <ReplyClick href={url}>{t('post:留言給', { author: userProfile.name })}</ReplyClick>
      </ReplyClickContainer>
      {b0Comments.length !== 0 &&
        b0Comments.map((comment) => (
          <CommentItem
            key={comment.replyID}
            comment={comment}
            url={url}
            subComments={comments.filter(({ b }) => b === comment.replyID)}
          />
        ))}
      <DownloadAppContainer>
        <DownloadAppImageBox>
          <amp-img
            width="480"
            height="169"
            layout="responsive"
            src="/statics/images/appDownloadBanner.png"
          />
          <DownloadAppClick href={downloadAppLink} target="_blank" />
        </DownloadAppImageBox>
      </DownloadAppContainer>
      <GliaCloudContainer>
        <div dangerouslySetInnerHTML={{ __html: '<amp-iframe sandbox="allow-scripts allow-same-origin" layout="responsive" src="https://video.adsparc.com/p/popdaily_com_tw_instream_amp/l/1648200502130077.html?inheritDimensions=true" width="720" height="405" frameborder="0" allowfullscreen resizable referrerpolicy="unsafe-url"><div overflow tabindex="0" role="button" aria-label="Expand player" placeholder>Expand player</div></amp-iframe>' }}></div>
      </GliaCloudContainer>
    </Container>
  )
}

export default CommentSection
